import { resourceReducer, getStatus } from 'redux-resource';
import { httpStatusCodes } from 'redux-resource-plugins';

const shippings = resourceReducer('shippings', {
  plugins: [httpStatusCodes],
});

export default shippings;

export const getShippingPrice = (state) =>
  state.requests &&
  state.requests.fetchEstimate &&
  state.requests.fetchEstimate.payload;
export const getShippingPriceStatus = (state) =>
  getStatus(state, 'requests.fetchEstimate.status');
export const getShippingPriceError = (state) =>
  state.requests &&
  state.requests.fetchEstimate &&
  state.requests.fetchEstimate.error;
